import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import { get, set } from 'global/lib/lodash';
import useRetrieveData from 'global/hooks/useRetrieveData';
import useDebounce from 'global/hooks/useDebounce';
import { FormControl, InputLabel, MenuItem, Select, Icon, IconButton } from '@material-ui/core';
import clsx from 'clsx';
import { uppercaseFirst } from 'global/utils';
import withRouter from 'react-router-dom/withRouter';
import sendData from 'redux/actions/sendData';
import { Loader, useScreen } from 'global/styles';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import * as moment from 'moment';
import SearchBar from 'global/components/SearchBar';
import arrayToTree from 'array-to-tree';
import { Row } from 'global/components/row';
import { Button } from 'global/components/Button';
import Modal from 'global/components/modal';
import Form from 'global/components/form';
import { useUser } from 'global/hooks/useUser';
import DndTable from 'global/components/DragTable';

export const StatusTypes = [
  { title: 'Archived', value: 'archived' },
  { title: 'Active', value: 'active' },
  { title: 'Draft', value: 'draft' },
];
export const DocumentTypes = [
  { title: 'Document', value: 'document' },
  { title: 'Course', value: 'course' },
];

export default withRouter((props) => {
  const { isMobile } = useScreen();
  const classes = useStyles({ isMobile });
  const [error, setError] = useState();
  const [state, setState] = useState({
    status: StatusTypes,
    statusValue: 0,
    typeValue: 0,
    types: DocumentTypes,
    selected: {},
    loading: false,
    search: '',
    selectedEdition: null,
  });
  const [createProps, setCreateProps] = useState({
    open: false,
    title: 'CREATE NEW EDITION',
    onClose: () => setCreateProps((s) => ({ ...s, open: false })),
  });

  const { me } = useUser();

  const debSearch = useDebounce(state.search, 700);

  const [params, setParams] = useState({});

  const transformData = (d) => {
    d = d.map((d) => ({ ...d, latestId: d.latestId == d.id ? null : d.latestId })).filter((f) => f.ownerRealmId == get(me, 'realm.id'));
    let treed = arrayToTree(d, { parentProperty: 'parentId' });

    treed = treed.map((tr) => {
      const all = [];

      const loopChildren = (arr, parent) => {
        arr.map((t) => {
          all.push({ ...t, parent });
          if (t.children) {
            loopChildren(t.children, t);
          }
        });
      };

      loopChildren(tr.children || []);

      tr.children = all;
      return tr;
    });

    let total = [];

    treed.map((tr) => {
      const trall = [tr, ...(tr.children || [])].map((t) => ({ ...t, parent: tr })).reverse();
      const top = trall.find((t) => t.id == tr.latestId);

      if (top) {
        delete top.parent;
        total = [...total, top, ...trall.filter((t) => t.id != top.id)];
      } else {
        total = [...total, tr];
      }
    });

    return total;
  };

  const editions = useRetrieveData(
    { url: '/editions' },
    {
      build: ['editions'],
      useEffect: true,
      params,
      transformData,
    }
  );

  const { data } = editions;

  useEffect(() => {
    const p = {
      page: { size: 500, number: 1 },
    };
    if (state.typeValue) {
      set(p, 'filter.edition_type', state.typeValue);
    } else if (state.typeValue === 0) {
      set(p, 'filter.edition_type', state.types.map((t) => t.value).join(','));
    }

    if (state.statusValue) {
      set(p, 'filter.status', state.statusValue);
    } else if (state.statusValue === 0) {
      set(p, 'filter.status', state.status.map((t) => t.value).join(','));
    }

    if (debSearch) {
      set(p, 'filter.name', debSearch);
    }

    setParams(p);
  }, [state.typeValue, state.statusValue, debSearch]);

  const selectRow = (row) => {
    props.history.push(`/account/content/edition/${row.id}`, { from: 'account/content' });
  };

  const openCreate = () => {
    let formState = {};

    const close = () => {
      setCreateProps((s) => ({
        ...s,
        open: false,
      }));
    };

    const submit = async () => {
      if (!formState.type || !formState.name) {
        return alert('Please complete all fields');
      }
      try {
        await sendData({
          url: `/editions`,
          method: 'post',
          data: {
            data: {
              type: 'editions',
              attributes: {
                name: formState.name,
                realm_id: get(me, 'realm.id'),
                edition_type: formState.type,
                status: 'draft',
              },
            },
          },
        });

        editions.update();
      } catch (err) {
        setError(err.message);
      } finally {
        close();
      }
    };

    setCreateProps((s) => ({
      ...s,
      open: true,
      content: () => (
        <Form
          showAllScreens
          onFormState={(fs) => (formState = fs)}
          screens={[
            {
              inputs: [
                {
                  id: 'type',
                  type: 'ToggleButton',
                  options: state.types,
                  props: {
                    exclusive: true,
                    label: 'Type',
                  },
                },
                {
                  id: 'name',
                  type: 'TextField',
                  defaultValue: () => '',
                  props: {
                    label: 'Title',
                    placeholder: 'Title',
                    autoFocus: true,
                    helperText: `A new Edition will be created in a "Draft" state, with no content. To add content after you create it, open the newly created Edition from the content list.`,
                  },
                },
              ],
            },
          ]}
        />
      ),
      buttons: [{ title: 'Create', onClick: submit, startIcon: <Icon>add</Icon> }],
    }));
  };

  return state.loading ? (
    <div className={clsx(classes.container, classes.flexRow, classes.pad20)}>
      <Loader />
    </div>
  ) : (
    <div className={classes.container}>
      {error && (
        <Alert
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setError();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {error}
        </Alert>
      )}

      <div>
        <Button onClick={openCreate} startIcon={<Icon>add</Icon>}>
          CREATE EDITION
        </Button>
        <SearchBar changeSearch={(t) => setState((s) => ({ ...s, search: t }))} containerStyle={classes.searchBar} />
      </div>

      <div className={classes.flexRow}>
        <FormControl className={classes.formControl}>
          <InputLabel>Status</InputLabel>
          <Select value={state.statusValue} onChange={(e) => setState((s) => ({ ...s, statusValue: e.target.value }))}>
            <MenuItem value={0}>Any</MenuItem>
            {state.status.map((sc) => (
              <MenuItem key={sc.value} value={sc.value}>
                {sc.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl className={classes.formControl}>
          <InputLabel>Type</InputLabel>
          <Select value={state.typeValue} onChange={(e) => setState((s) => ({ ...s, typeValue: e.target.value }))}>
            <MenuItem value={0}>Any</MenuItem>
            {state.types.map((sc) => (
              <MenuItem key={sc.value} value={sc.value}>
                {sc.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className={classes.table}>
        {editions.loading && (
          <div className={clsx(classes.flexRow, classes.pad20)}>
            <Loader />
          </div>
        )}
        {!editions.loading && <DndTable columns={COLUMNS} canDrag={false} onSelectRow={selectRow} items={data} />}
      </div>

      <Modal {...createProps} />
    </div>
  );
});

const COLUMNS = [
  {
    field: 'name',
    title: 'Title',
    width: 200,
    render: (row) => {
      return (
        <Row>
          {row.parent && <Icon className="parentIcon">{'keyboard_return'}</Icon>}
          {get(row, 'name')}
        </Row>
      );
    },
  },
  {
    field: 'editionType',
    title: 'Type',
    width: 200,
    render: (row, text) => {
      return uppercaseFirst(text);
    },
  },
  {
    field: 'status',
    title: 'Status',
    width: 100,
    render: (row, text) => {
      return uppercaseFirst(text);
    },
  },
  {
    field: 'createdAt',
    title: 'Created',
    width: 100,
    render: (row, text) => {
      return moment(text).format('ll');
    },
  },
];
